// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Subscriptions_AdminSubscriptionRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Subscriptions_AdminSubscriptionRow — one row for GET /subscriptions/admin/list.
 *
 * Covers ALL statuses (live + terminal history) for ALL franchises.
 * franchise_name is injected by the controller (not stored in franchises_subscriptions).
 * Datetime fields are ISO-8601 UTC strings (controller converts GMT-3 before fromRows()).
 * is_live and days_remaining are derived by the controller from status + horizon datetimes.
 *
 * S12/M3d widened this row from the 8 display columns to the WHOLE subscription
 * plus its market, because /config/assinaturas now opens a detail modal showing
 * every field. Three groups:
 *
 *   ROSTER      subscription_id, franquia_id, franchise_name, plan_name, status,
 *               started_at, current_period_end, grace_until, days_remaining, is_live
 *   GATEWAY     provider (the charge route this subscription actually runs on),
 *               provider_customer_id, provider_subscription_id
 *   MARKET      currency + price_provider_code, read through plan_price_id — the
 *               price row the subscription is PINNED to. A subscription without a
 *               pin keeps both NULL; the plan's other price rows are not its price.
 *
 * Every field below is nullable on purpose: the roster also emits SYNTHETIC rows
 * for franchises with no subscription at all (so staff can grant a grace window
 * from them), and on those there is nothing to report. NULL means "unknown / not
 * applicable" and is rendered as such — never defaulted to 0 or to a guess.
 */
import { registerContract } from './validate'

export interface Subscriptions_AdminSubscriptionRow {
franquia_id: number
subscription_id?: number
franchise_name?: string
plan_name?: string
status?: string
started_at?: string
current_period_end?: string
grace_until?: string
days_remaining?: number
is_live?: boolean
provider?: string
provider_customer_id?: string
provider_subscription_id?: string
currency?: string
price_provider_code?: string
name?: string
description?: string
plan_id?: number
plan_price_id?: number
exempt?: boolean
setup_paid?: boolean
paid_through?: string
current_period_start?: string
grace_period_end?: string
created_at?: string
updated_at?: string
setup_status?: string
}

registerContract('Subscriptions_AdminSubscriptionRow', {
  franquia_id:              { type: 'number',  required: true },
  subscription_id:          { type: 'number',  required: false },
  franchise_name:           { type: 'string',  required: false },
  plan_name:                { type: 'string',  required: false },
  status:                   { type: 'string',  required: false },
  started_at:               { type: 'string',  required: false },
  current_period_end:       { type: 'string',  required: false },
  grace_until:              { type: 'string',  required: false },
  days_remaining:           { type: 'number',  required: false },
  is_live:                  { type: 'boolean', required: false },
  provider:                 { type: 'string',  required: false },
  provider_customer_id:     { type: 'string',  required: false },
  provider_subscription_id: { type: 'string',  required: false },
  currency:                 { type: 'string',  required: false },
  price_provider_code:      { type: 'string',  required: false },
  name:                     { type: 'string',  required: false },
  description:              { type: 'string',  required: false },
  plan_id:                  { type: 'number',  required: false },
  plan_price_id:            { type: 'number',  required: false },
  exempt:                   { type: 'boolean', required: false },
  setup_paid:               { type: 'boolean', required: false },
  paid_through:             { type: 'string',  required: false },
  current_period_start:     { type: 'string',  required: false },
  grace_period_end:         { type: 'string',  required: false },
  created_at:               { type: 'string',  required: false },
  updated_at:               { type: 'string',  required: false },
  setup_status:             { type: 'string',  required: false },
})
